export default "__VITE_ASSET__a5d4bb32__"